import TransferProfile from './TransferProfile';
import CopyProfile from './CopyProfile';

export default {
  TransferProfile,
  CopyProfile,
};
